<template>
  <div style="display: flex;align-items: center">
    <el-input ref="mblHeader" v-model="prefix" :disabled="editable" maxlength="3" style="width: 70px;" no="1" @input="mblHeaderChangeHandler" @focus="onFocus('headerFocused')" @blur="onBlur('headerFocused')" />
    <span style="padding-right: 1.5px;padding-left: 1.5px;">-</span>
    <el-input ref="mblFooter" v-model="mawbNo" :disabled="editable" maxlength="8" style="width: 130px;" no="2" @input="mblFooterChangeHandler" @focus="onFocus('footerFocused')" @blur="onBlur('footerFocused')" />
  </div>
</template>

<script>

import Vue from 'vue'
export default Vue.extend({
  name: 'MawbNoInput',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: { type: String, default: null },
    editable: { type: Boolean, default: true }
  },
  data() {
    return {
      prefix: '', // 主单号前三位数
      mawbNo: '', // 主单号后八位数字
      text: '',
      headerFocused: false,
      footerFocused: false,
      originValue: ''
    }
  },
  watch: {
    value(newValue) {
      this.text = newValue
    },
    text(newValue) {
      if (newValue) {
        if (newValue.length === 11) {
          this.prefix = newValue.substring(0, 3)
          this.mawbNo = newValue.substring(3)
        } else if (newValue.length === 3) {
          this.prefix = newValue
          this.mawbNo = ''
        }
      } else {
        this.prefix = ''
        this.mawbNo = ''
      }
    }
  },
  created() {
    this.text = this.value
  },
  methods: {
    mblHeaderChangeHandler() {
      let text = ''
      if (this.prefix && this.prefix.trim()) {
        text = this.prefix
        if (this.prefix.length === 3 && (!this.mawbNo || this.mawbNo.length === 0)) {
          this.$refs.mblFooter.focus()
        }
      }
      if (this.mawbNo && this.mawbNo.trim()) {
        text = text + this.mawbNo
      }
      this.$emit('change', text)
    },
    mblFooterChangeHandler() {
      let text = ''
      if (this.prefix && this.prefix.trim()) {
        text = this.prefix
      }
      if (this.mawbNo && this.mawbNo.trim()) {
        text = text + this.mawbNo
      }
      if (!this.mawbNo) {
        this.$refs.mblHeader.focus()
      }
      this.$emit('change', text)
    },
    onFocus(name) {
      if (!this.headerFocused && !this.footerFocused) {
        this.originValue = this.value
      }
      this[name] = true
    },
    onBlur(name) {
      this[name] = false
      setTimeout(() => {
        if (!this.headerFocused && !this.footerFocused) {
          if (this.value !== this.originValue) {
            this.$emit('changeCallback', this.value)
          }
        }
      })
    },
    /**
     *
     * @param mbl
     * @param flg
     */
    splitMbl(mbl, flg) {
      if (flg) {
        this.prefix = mbl.substring(0, 3)
        this.mawbNo = mbl.substring(3)
      }
    }
  }
})
</script>
